import axios from 'axios';
import apiBaseUrl from '@/plugins/api/apiBaseUrl';

export default class Optionals {
  public static async get(): Promise<GetOptionalsResponse> {
    const response = await Optionals.instance.get<GetOptionalsResponse>('/optionals.php');
    return response.data;
  }

  private static instance = axios.create({
    baseURL: apiBaseUrl,
  });
}
